import {DialogManager} from '@modifi/plugin-dialogs'
import {CustomerDialogLayout} from '@modifi/ui'

DialogManager.setDefaultLayout(CustomerDialogLayout)
